<template>
  <div class="promotion-qt"> 
    <div class="bg-images">
      <img class="bg-top pc-show" src="../../../../static/img/promotion/top_bg_app.png" alt="bg-top">
      
      <div class="left-org"></div>
      <div class="right-blu-circle">
        <div></div>
      </div>
      <div class="right-blu"></div>
      <img class="bg-bottom" src="../../../../static/img/promotion/bg-bottom.png" alt="">
    </div>

    <div class="top pc-show">
      <div class="top-content">
        <div>
          <div class="email">
            <img src="../../../../static/img/promotion/email.png" alt="">
            <span>{{$t('top_email')}}</span>
          </div>
          <div class="telegram">
            <img src="../../../../static/img/promotion/telegram.png" alt="" class="telegram">
            <span>{{$t('top_telegram')}}</span>
          </div>
        </div>
        <div class="faq">
          <img src="../../../../static/img/promotion/faq.png" alt="">
          <a href="Https://t.me/joinchat/EHER6Q0FAGp1rNLajkldPA">{{$tc('top_faq', 1)}}</a>
          <router-link to="/faq">{{$tc('top_faq', 2)}}</router-link>
        </div>
      </div>
    </div>
    <plex-header class="pc-show" style="width:100%"></plex-header>

    <div class="container">
      <div class="container-top">
        <plex-header class="phone-show" style="width:100%"></plex-header>
        <img class="phone-show" src="../../../../static/img/promotion/app.png" alt="qt" style="width:100%">
        <div class="right-top">
          <h4>{{$t('features')}}</h4>
          <span></span>
          <div>
            <div><img class="features_mark" src="../../../../static/img/promotion/features_mark.png" alt=""><span>{{$t('features_con1')}}</span></div>
            <div><img class="features_mark" src="../../../../static/img/promotion/features_mark.png" alt=""><span>{{$t('features_con2')}}</span></div>
            <div><img class="features_mark" src="../../../../static/img/promotion/features_mark.png" alt=""><span>{{$t('features_con3')}}</span></div>
            <div><img class="features_mark" src="../../../../static/img/promotion/features_mark.png" alt=""><span>{{$t('features_con4')}}</span></div>
            <div><img class="features_mark" src="../../../../static/img/promotion/features_mark.png" alt=""><span>{{$t('features_con5')}}</span></div>
          </div>
          <router-link to='/'>{{$t('features_btn')}}</router-link>
          <img class="seven-days" src="../../../../static/img/promotion/7-days.png" alt="7-days">
        </div>
      </div>

      <div class="platform pc-show">
        <p>
          <router-link to="/download?platform=windows" class="download-link" aria-label="windows">
          <span>
            <svg class="icon"><use xlink:href="#icon-windows"></use></svg>
            </span>Windows</router-link>
          <router-link to="/download?platform=mac" class="download-link" aria-label="mac"><span><svg class="icon"><use xlink:href="#icon-Macos"></use></svg></span>Mac</router-link>
          <router-link to="/download?platform=ios" class="download-link" aria-label="ios"><span><svg class="icon"><use xlink:href="#icon-pingguo"></use></svg></span>iOS</router-link>
          <router-link to="/download?platform=android" class="download-link" aria-label="android"><span><svg class="icon"><use xlink:href="#icon-anzhuo"></use></svg></span>Android</router-link>
          <router-link to="/download?platform=ubuntu" class="download-link" aria-label="ubuntu"><span><svg class="icon"><use xlink:href="#icon-Ubuntu"></use></svg></span>Ubuntu</router-link>
          <router-link to="/download?platform=androidTV" class="download-link" aria-label="android_tv"><span><svg class="icon"><use xlink:href="#icon-androidTV"></use></svg></span>Android TV</router-link>
        </p>
      </div>
      <div class="platform-h5 phone-show">
        <img src="../../../../static/img/promotion/download.png" style="width:100%">
      </div>

      <div class="simple-steps pc-show">
        <h4>{{$t('steps')}}</h4>
        <span></span>
        <div class="steps-img">
          <img src="../../../../static/img/promotion/steps_app1.png" alt="">
          <div class="arrow">
            <span></span><span></span><span></span>
          </div>
          <img src="../../../../static/img/promotion/steps_app2.png" alt="">
          <div class="arrow">
            <span></span><span></span><span></span>
          </div>
          <img src="../../../../static/img/promotion/steps_app3.png" alt="">
        </div>
        <div class="steps-text">
          <span>{{$t('steps_num1')}}</span>
          <span>{{$t('steps_num2')}}</span>
          <span>{{$t('steps_num3')}}</span>
        </div>
        <router-link to="/download" class="down-btn">{{$t('steps_btn')}}</router-link>
      </div>
      <div class="simple-steps phone-show">
        <h4>{{$t('steps')}}</h4>
        <span></span>
        <div class="steps">
          <div class="steps-text">
            <img src="../../../../static/img/promotion/steps_app1.png" alt=""> <span>{{$t('steps_num1')}}</span>
          </div>
          <div class="steps-text">
            <img src="../../../../static/img/promotion/steps_app2.png" alt=""> <span>{{$t('steps_num2')}}</span>
          </div>
          <div class="steps-text">
            <img src="../../../../static/img/promotion/steps_app3.png" alt=""> <span>{{$t('steps_num3')}}</span>
          </div>
        </div>
        <router-link to="/download" class="down-btn">{{$t('steps_btn')}}</router-link>
      </div>

      <div class="features">
        <h4>{{$t('main_features')}}</h4>
        <span></span>
        <div class="ftu-text1">
          <div>
            <img src="../../../../static/img/promotion/ftu_01.png" alt="">
            <span>{{$t('main_features_title1')}}</span>
            <span class="small">{{$t('main_features_con1')}}</span>
          </div>
          <div>
            <img src="../../../../static/img/promotion/ftu_02.png" alt="">
            <span>{{$t('main_features_title2')}}</span>
            <span class="small">{{$t('main_features_con2')}}</span>
          </div>
          <div>
            <img src="../../../../static/img/promotion/ftu_03.png" alt="">
            <span>{{$t('main_features_title3')}}</span>
            <span class="small">{{$t('main_features_con3')}}</span>
          </div>
        </div>
        <div class="ftu-text2">
          <div>
            <img src="../../../../static/img/promotion/ftu_04.png" alt="">
            <span>{{$t('main_features_title4')}}</span>
            <span class="small">{{$t('main_features_con4')}}</span>
          </div>
          <div>
            <img src="../../../../static/img/promotion/ftu_05.png" alt="">
            <span>{{$t('main_features_title5')}}</span>
            <span class="small">{{$t('main_features_con5')}}</span>
          </div>
          <div>
            <img src="../../../../static/img/promotion/ftu_06.png" alt="">
            <span>{{$t('main_features_title6')}}</span>
            <span class="small">{{$t('main_features_con6')}}</span>
          </div>
        </div>
      </div>

      <div class="reviews">
        <h4>{{$t('reviews')}}</h4>
        <span></span>
        <div class="carousel">
          <review-text></review-text>
        </div>
      </div>
      
      <div class="faqs">
        <h4>{{$t('faqs')}}</h4>
        <span></span>
        <div>
          <span>{{$t('faqs_title1')}}</span>
          <span class="small">{{$t('faqs_con1')}}</span>
        </div>
        <div>
          <span>{{$t('faqs_title2')}}</span>
          <span class="small">{{$t('faqs_con2')}}</span>
        </div>
        <div>
          <span>{{$t('faqs_title3')}}</span>
          <span class="small">{{$t('faqs_con3')}}</span>
        </div>
        <router-link to="/download" class="down-btn">{{$t('steps_btn')}}</router-link>
      </div>

      <div class="footer">
        <span>{{$t('footer')}}</span>
        <img class="left-mark" src="../../../../static/img/promotion/left_mark.png" alt="">
        <img class="right-mark" src="../../../../static/img/promotion/right_mark.png" alt="">
      </div>

      <div class="top phone-show">
        <div class="top-content">
          <div class="email">
            <img src="../../../../static/img/promotion/email.png" alt="">
            <span>{{$t('top_email')}}</span>
          </div>
          <div class="telegram">
            <img src="../../../../static/img/promotion/telegram.png" alt="" class="telegram">
            <span>{{$t('top_telegram')}}</span>
          </div>
          <div class="faq">
            <img src="../../../../static/img/promotion/faq.png" alt="">
            <a href="Https://t.me/joinchat/EHER6Q0FAGp1rNLajkldPA">{{$tc('top_faq', 1)}}</a>
            <router-link to="/faq">{{$tc('top_faq', 2)}}</router-link>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import locales from './lang'
import PlexHeader from '../../../components/plexHeader/mainHeader/Index.vue'
import ReviewText from './ReviewText.vue'
import cookie from '../../../lib/cookie'

export default {
  name: 'promotion-qt',
  components: {PlexHeader, ReviewText},
  locales,
  created: function () {
    this.$store.commit('isSpecialHeader', true)
    cookie.setCookie('promotion_source', 'promotion-app', 30)
  },
  destroyed() {
    this.$store.commit('isSpecialHeader', false)
  },
  methods: {
    choose(index) {
      index++
      document.getElementById('banner').style.left = -430 * index + 'px'
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import '../../../assets/scss/common.scss';
  .promotion-qt {
    position: relative;
    .bg-images {
      img {
        position: absolute;
      }
      .bg-top {
        top: 48px;
        z-index: -1;
        height: 760px;
        width: 100%;
        left: 0;
        right: 0;
      }
      .seven-days {
        top: 100%;
        right: 10%;
        height: 264px;
        width: 218px;
      }
      .left-org {
        position: absolute;
        top: 49.5%;
        left: -20px;
        z-index: -1;
        height: 240px;
        width: 120px;
        background-color: #FFD750;
        border-radius: 0 240px 240px 0;
      }
      .right-blu-circle {
        position: absolute;
        top: 41%;
        right: 0px;
        z-index: -1;
        height: 380px;
        width: 120px;
        overflow: hidden;
        div {
          height: 380px;
          width: 190px;
          background-color: #5968F9;
          border-radius: 390px 0 0 390px;
        }
      }
      .right-blu {
        position: absolute;
        top: 39%;
        right: 45px;
        z-index: -1;
        height: 85px;
        width: 85px;
        background-color: #5968F9;
        border-radius: 50%;
      }
      .bg-bottom {
        z-index: -1;
        width: 100%;
        bottom: 880px;
        left: 0;
        right: 0;
      }
    }
    .top {
      font-size: 14px;
      line-height: 17px;
      letter-spacing: 0;
      color: #FFFFFF;
      background-color: #1C1D29;
      .top-content {
        display: flex;
        justify-content: space-around;
        width: 90%;
        height: 48px;
        margin: 0 auto;
        line-height: 48px;
        div {
          display: inline-block;
          img {
          height: 14px;
          width: 14px;
          margin-right: 13px;
          }
          img.telegram {
            height: 15px;
            width: 15px;
            margin: 0 12.5px 0 80.5px;
          }
          a {
            color: #FFF;
          }
        }
      }
    }
    .container {
      z-index: 111111;
      max-width: 1280px;
      padding: 0;
      margin: 0 auto;
      background: transparent;
      .container-top {
        position: relative;
        height: 760px;
        width: 100%;
        .seven-days {
          position: absolute;
          bottom: 75px;
          right: 5%;
          height: 264px;
          width: 218px;
        }
      }
      .right-top {
        float: right;
        width: 50%;
        margin-top: 100px;
        color: #FFFFFF;
        h4 {
          margin: 0;
          margin-bottom: 18px;
          font-size: 32px;
          font-weight: 900;
          letter-spacing: 1.87px;
          line-height: 39px;
        }
        >span {
          display: block;
          height: 4px;
          width: 60px;
          background-color: #FFFFFF;
        }
        >div {
          margin: 34px 0 38px;
          font-size: 18px;
          font-weight: 900;
          letter-spacing: 1.05px;
          div {
            display: flex;
            align-items: flex-start;
            img {
              display: inline-block;
              height: 22px;
              width: 22px;
              margin-right: 8px;
            }
          }
          div~div {
            margin-top: 15px;
          }
        }
        a {
          display: block;
          height: 66px;
          width: 260px;
          font-size: 24px;
          line-height: 66px;
          letter-spacing: 1.4px;
          color: #9D5FFF;
          text-align: center;
          border-radius: 100px;
          background-color: #FFFFFF;
        }
      }
      .platform {
        margin-top: 90px;
        text-align: center;
        p {
          display: flex;
          justify-content: center;
          width: 100%;
        }
        a~a {
          margin-left: 50px;
        }
        .download-link {
          display: flex;
          height: 32px;
            line-height: 32px;
          font-size: 20px;
          letter-spacing: 1.17px;
          color: #999999;
          opacity: 0.6;
          span {
            display: inline-block;
            height: 32px;
            .icon {
              margin-right: 15px;
              font-size: 32px;
            }
          }
        }
      }
      .simple-steps {
        margin-top: 90px;
        text-align: center;
        .steps-img {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 20px 0 60px;
          img {
            width:340px;
          }
          .arrow {
            span {
              display: inline-block;
              height: 0;
              width: 0;
              border-width: 12px 0 12px 18px;
              border-style: solid;
            }
            span:nth-child(1) {
              border-color: transparent transparent transparent rgba(9, 9, 9, 0.1);
            }
            span:nth-child(2) {
              border-color: transparent transparent transparent rgba(9, 9, 9, 0.3);
            }
            span:nth-child(3) {
              border-color: transparent transparent transparent rgba(9, 9, 9, 0.6);
            }
            span~span {
              margin-left: 8px;
            }
          } 
        }
        .steps-text {
          display: flex;
          justify-content: space-between;
          span {
            display: inline-block;
            width: 340px;
            font-size: 18px;
            font-weight: 900;
            letter-spacing: 1.05px;
            line-height: 34px;
            color: #666666;
            text-align: left;
          }
        }
      }
      .features {
        text-align: center;
        img {
          height: 49.77px;
          width: 50px;
        }
        .ftu-text1, .ftu-text2 {
          display: flex;
          justify-content: space-between;
          div {
            width: 340px;
            img {
              margin-bottom: 30px;
            }
            span {
              display: block;
              font-size: 18px;
              font-weight: 900;
              letter-spacing: 1.05px;
              line-height: 22px;
              color: #666666;
            }
            span.small {
              margin-top: 30px;
              font-weight: 400;
              color: #999999;
            }
          }
        }
        .ftu-text1 {
          margin-top: 90px;
        }
        .ftu-text2 {
          margin: 101px 0 190px;
        }
      }
      .reviews {
        text-align: center;
        .carousel {
          width: 90%;
          margin: 60px auto 0;
          position: relative;
          overflow: hidden;
        }
      }
      .faqs {
        margin-top: 180px;
        text-align: center;
        div {
          margin-top: 50px;
        }
        span {
          display: block;
          font-size: 18px;
          font-weight: 900;
          letter-spacing: 1.05px;
          line-height: 22px;
          text-align: left;
          color: #666666;
        }
        span.small {
          margin-top: 20px;
          font-weight: 400;
          color: #999999;
        }
      }
      .footer {
        position: relative;
        width: 80%;
        height: auto;
        margin: 0 auto 268px;
        font-size: 16px;
        font-weight: 900;
        letter-spacing: 0;
        line-height: 24px;
        color: #999999;
        text-align: center;
        span {
          display: inline-block;
          height: auto;
          margin: 15px 37px;
          vertical-align: middle;
        }
        img {
          position: absolute;
          height: 30px;
          width: 37px;
        }
        img.left-mark {
          top: 0;
          left: 0;
        }
        img.right-mark {
          bottom: 0;
          right: 0;
        }
      }
      .simple-steps>h4, .features>h4, .reviews>h4, .faqs>h4 {
        font-size: 32px;
        font-weight: 900;
        letter-spacing: 1.87px;
        line-height: 39px;
        color: #282828;
      }
      .simple-steps>span, .features>span, .reviews>span, .faqs>span {
        display: inline-block;
        height: 4px;
        width: 60px;
        background: linear-gradient(125.23deg, #416CF8 0%, #EC55FF 100%);
      }
      .simple-steps>.down-btn, .faqs>.down-btn {
        display: inline-block;
        height: 66px;
        width: 350px;
        margin: 100px 0 190px;
        font-size: 24px;
        letter-spacing: 1.4px;
        line-height: 66px;
        color: #FFFFFF;
        text-align: center;
        border-radius: 100px;
        background: linear-gradient(125.23deg, #416CF8 0%, #EC55FF 100%);
      }
      .faqs>.down-btn {
        margin-bottom: 100px;
      }
    }

    .phone-show {
      display: none;
    }
    .pc-show {
      display: block;
    }
    @media screen and (max-width: 768px) {
      .phone-show {
        display: block;
      }
      .pc-show {
        display: none;
      }

      .bg-images {
        .bg-bottom {
          height: px2rem(986);
          bottom: px2rem(1400);
        }
      }
      .container {
        .right-top {
          float: none;
          width: 90%;
          margin: px2rem(40) auto px2rem(40);
          padding-bottom: px2rem(146);
          h4 {
            text-align: center;
            margin-bottom: px2rem(18);
            font-size: px2rem(32);
            letter-spacing: px2rem(1.87);
            line-height: px2rem(39);
          }
          >div {
            margin: px2rem(34) 0 px2rem(38);
            font-size: px2rem(18);
            div {
              img {
                height: px2rem(22);
                width: px2rem(22);
                margin-right: px2rem(8);
              }
            }
            div~div {
              margin-top: px2rem(15);
            }
          }
          >span, a {
            margin: 0 auto;
          }
          a {
            height: px2rem(66);
            width: px2rem(260);
            font-size: px2rem(24);
            line-height: px2rem(66);
            letter-spacing: px2rem(1.4);
            border-radius: px2rem(100);
          }
        }
        .container-top {
          height: auto;
          background-image: url('../../../../static/img/promotion/top_bg_h5.png');
          background-size: 100% 100%;
          .seven-days {
            bottom: px2rem(-60);
            height: px2rem(180);
            width: px2rem(148);
          }
        }
        .platform-h5 {
          width: 90%;
          margin: px2rem(94) auto 0;
        }
        .simple-steps {
          width: 90%;
          margin: px2rem(90) auto 0;
          .steps {
            .steps-text {
              margin-top: px2rem(30);
              img {
                height: px2rem(117);
                width: px2rem(130);
              }
              span {
                font-size: px2rem(18);
                font-weight: 400;
                letter-spacing: 0;
                line-height: px2rem(24);
              }
            }
          }
          .down-btn {
            width: 100%;
            margin: px2rem(60) 0 px2rem(100);
          }
        }
        .features {
          width: 90%;
          margin: 0 auto;
          img {
            height: px2rem(49.77);
            width: px2rem(50);
          }
          .ftu-text1, .ftu-text2 {
            flex-wrap: wrap;
            margin: 0;
            div {
              width: 100%;
              margin-top: px2rem(50);
              img {
                margin-bottom: px2rem(15);
              }
              span {
                font-size: px2rem(18);
                letter-spacing: px2rem(1.05);
                line-height: px2rem(22);
              }
              span.small {
                margin-top: px2rem(12);
              }
            }
          }
          .ftu-text2 {
            margin-bottom: px2rem(90);
          }
        }
        .reviews {
          h4 {
            width: 90%;
            margin: 0 auto;
          }
          .carousel {
            width: 100%;
            margin: px2rem(21) auto 0;
          }
        }
        .faqs {
          width: 90%;
          margin: px2rem(90) auto 0;
          div {
            margin-top: px2rem(50);
          }
          span {
            font-size: px2rem(18);
            letter-spacing: px2rem(1.05);
            line-height: px2rem(22);
          }
          span.small {
            margin-top: px2rem(20);
          }
          .down-btn {
            width: 100%;
            margin: px2rem(60) 0 px2rem(70);
          }
        }
        .footer {
          width: 90%;
          margin: 0 auto px2rem(60);
          font-size: px2rem(16);
          line-height: px2rem(24);
          span {
            margin: px2rem(15) px2rem(37);
          }
          img {
            height: px2rem(10);
            width: px2rem(11);
          }
        }
        .top {
          font-size: px2rem(14);
          .top-content {
            display: block;
            width: 100%;
            margin: 0;
            padding: px2rem(15) 0 px2rem(15) px2rem(25);
            height: auto;
            line-height: 0;
            div {
              display: block; 
              img {
              height: px2rem(14);
              width: px2rem(14);
              margin-right: px2rem(13);
              }
              img.telegram {
                margin: 0 px2rem(13) 0 0;
              }
            }
            div~div {
              margin-top: px2rem(15);
            }
          }
        }
        .simple-steps>h4, .features>h4, .reviews>h4, .faqs>h4 {
          font-size: px2rem(32);
          letter-spacing: px2rem(1.87);
          line-height: px2rem(39);
        }
        .simple-steps>.down-btn, .faqs>.down-btn {
          height: px2rem(66);
          font-size: px2rem(24);
          letter-spacing: px2rem(1.4);
          line-height: px2rem(66);
          border-radius: px2rem(100);
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// App.vue?6c0a072c